import { PatientLegal } from './PatientLegal'

const PatientLegalOptions = [
  { text: 'I am currently involved in a Bankruptcy Action', value: PatientLegal.BANKRUPTCY },
  { text: 'I owe back child support', value: PatientLegal.CHILD_SUPPORT },
  { text: 'I have hired an attorney', value: PatientLegal.HIRED_ATTORNEY }
]

export default PatientLegalOptions
